export default "__VITE_ASSET__C7M9SYxV__"